import Img from "components/Commons/Image/Image"
import ContractorSummaryProductCardStyled from "components/Contractor/OrderDetail/SummaryProducts/SummaryProductCard/SummaryProductCard.styled"
import { IconCheck, IconReject } from "theme/common/Icon.styled"
import { getFormatedSeriesProduct } from "helpers/UtilsHelper"

const ContractorSummaryProductCard = ({
  itemOrder,
  hasIcon = false,
}: {
  itemOrder: any
  hasIcon?: boolean
}) => {
  const isQuantityComplete = itemOrder.quantity === itemOrder.custom?.quantityReceived;
  
  return (
    <ContractorSummaryProductCardStyled 
      hasIcon={hasIcon} 
      isConfirm={itemOrder.isConfirm}
      isQuantityComplete={isQuantityComplete}
    >
      <p className="item-name">{itemOrder.name}</p>
      <div className="body-product-card">
        <div className="info-tem">
            {itemOrder.sku && <p><span className="relevant-title">SKU: </span>{itemOrder.sku}</p>}
            {itemOrder.categories && itemOrder.categories.length > 0 && <p><span className="relevant-title">Categoría: </span>{itemOrder.categories.map((category: any) => category).join("-")}</p>}  
            {itemOrder.quantity !== undefined && <p><span className="relevant-title">Cantidad Enviadas: </span>{itemOrder.quantity}</p>}
            {itemOrder.custom?.quantityReceived !== undefined && <p><span className="relevant-title">Cantidad Recibidas: </span>{itemOrder.custom.quantityReceived}</p>}
            {itemOrder.custom?.series && <p><span className="relevant-title">Series Enviadas: </span>{getFormatedSeriesProduct(itemOrder.custom.series)}</p>}
            {itemOrder.custom?.seriesReceived && itemOrder.custom.seriesReceived !== "0" && <p><span className="relevant-title">Series Recibidas: </span>{getFormatedSeriesProduct(itemOrder.custom.seriesReceived)}</p>}
        </div>

        {itemOrder.custom?.thumbnail && (
          <Img url={itemOrder.custom.thumbnail} alt={itemOrder.name} />
        )}
        {hasIcon ? itemOrder.isConfirm ? <IconCheck /> : <IconReject /> : null}
      </div>
    </ContractorSummaryProductCardStyled>
  )
}

export default ContractorSummaryProductCard
